angular.module('bmsApp.resource')
	.controller('ResourceResourceMoveDialogCtrl', [
		'notify',
		'ResourceSvc',
		'$modalInstance',
		'resource',
		function (notify,
				  ResourceSvc,
				  $modalInstance,
				  resource) {

			var self = this;
			angular.extend(self, {
				loading: false,
				promise: undefined,
				resource: resource,
				methods: {
					init: init,
					cancel: cancel,
					submit: submit,
					open: directoryOpen
				}
			});

			function init() {
				// open the destination list, starting where this resource is currently located
				directoryOpen(self.resource.directory ? self.resource.directory.id : null);
			}

			function directoryOpen(id) {
				self.loading = true;
				return ResourceSvc.directory.read({
					id: id,
					group: 'my_files'
				})
					.then(function (response) {
						self.currentDir = response.data.current_directory;
						self.childDirs = response.data.child_directory_collection;
						self.loading = false;

						return response;
					}, function (errors) {
						ResourceSvc.displayErrors(errors);
					});
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				self.promise = ResourceSvc.resource.update(angular.extend(self.resource, {
					directory: self.currentDir
				}));
				self.promise.then(function () {
					notify({
						message: 'File moved successfully.'
					});
					$modalInstance.close();
				}, function (errors) {
					ResourceSvc.displayErrors(errors);
				});
			}

		}
	]);
